<script setup>
  import {ref} from "vue";

  import ComponentDialog from "@components/Dialogs/Dialog.vue";

  defineOptions({
    name: "ComponentConfirmationDialog",
  });

  defineProps({
    title: {
      type: String,
      required: true,
    },
    content: {
      type: String,
      default: null,
    },
    primaryLabel: {
      type: String,
      default: "OK",
    },
    dialogWidth: {
      type: String,
      default: "small",
    },
  });

  const emit = defineEmits(["confirmed"]);

  const refConfirmationDialog = ref(null);

  // allows to "store" a payload while the dialog is open
  let payload = null;

  function confirm() {
    emit("confirmed", payload);
    close();
  }

  function open(value) {
    payload = value ?? null;
    refConfirmationDialog.value.open();
  }

  function close() {
    refConfirmationDialog.value.close();
  }

  defineExpose({
    open,
    close,
  });
</script>

<template>
  <ComponentDialog
    ref="refConfirmationDialog"
    :dialog-title="title"
    :dialog-content="content"
    :dialog-width="dialogWidth"
    :primary-label="primaryLabel"
    :test-id="getTestId('confirmation')"
    @primary-button-clicked="confirm()"
    @cancel-button-clicked="close()"
  >
    <template v-if="$slots.content" #content>
      <slot name="content" />
    </template>
  </ComponentDialog>
</template>
